module.exports = __webpack_public_path__ + "static/media/test6_2.c95ef6fd.png";